import { useState } from 'react';
import { RouterSuspense } from '@/common/components/RouterSuspense/RouterSuspense';
import { safeLazy } from '@/common/utils/import';

const { EarnedWageAccessHome } = safeLazy(
  () => import('@/web/containers/EarnedWageAccess/EarnedWageAccess')
);

export default function EarnedWageAccessPage() {
  const [displayLearningCentre, setDisplayLearningCentre] = useState<boolean>();

  return (
    <RouterSuspense>
      <EarnedWageAccessHome
        displayLearningCentre={displayLearningCentre}
        setDisplayLearningCentre={setDisplayLearningCentre}
      />
    </RouterSuspense>
  );
}
